import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { ContractModificationTypes, Contract, ContractDisplayTypes } from "../../types/contracts";

import ChangeAddress from "./components/ChangeAddress";
import ChangeIban from "./components/ChangeIban";
import ChangePower from './components/ChangePower';
import ReclamATC from "../../../ReclamATC/components/ReclamATC";
import NoSIPSCession from "./components/NoSIPSCession";
import ChangeRefCatastral from "./components/ChangeRefCatastral";
import ChangeInvoiceOnline from "./components/ChangeInvoiceOnline";

// import ElectronicNotification from "../DetailsPanels/components/ElectronicNotificationAction";

interface IModificationDialogProps {
  contract: Contract,
  formContent: ContractModificationTypes,
  type: ContractDisplayTypes,
  handleDialogClose: () => void
}

const ModificationDialog = ({
  contract,
  formContent,
  type,
  handleDialogClose
}: IModificationDialogProps) => {

  // TODO: Invoice online https://github.com/gisce/oficina-virtual/pull/872/files#diff-30003d91fc2a177584abcd4c9e42dded8a3d29854bc798460cd0fa698c3554fb

  return <Dialog
    open={!!formContent}
    onClose={handleDialogClose}
    fullWidth={true}
    maxWidth={'lg'}
  >

    {(["noSIPSCession", "iban", "power", "refCatastral", "address", "invoiceOnline"] as ContractModificationTypes[]).includes(formContent) ? (
      <>
        {/* {formContent === "elecNotif" && <ElectronicNotification
          setElectronicNotification={}
          onClose={handleDialogClose}
        
        />} */}
        
        {formContent === "noSIPSCession" && <NoSIPSCession
          contractName={contract.name}
          isWaitingForSignature={contract.no_cession_sips.waiting_for_signature}
          type={type}
          onDialogClose={handleDialogClose}
        />}
        {formContent === "iban" && <ChangeIban onClose={handleDialogClose} type={contract.type}/>}
        {formContent === "power" && <ChangePower onClose={handleDialogClose}/>}
        {formContent === "refCatastral" && <ChangeRefCatastral type={contract.type} onClose={handleDialogClose}/>}
        {formContent === "address" && <ChangeAddress type={type} onClose={handleDialogClose}/>}
        {formContent === "invoiceOnline" && <ChangeInvoiceOnline type={contract.type} onClose={handleDialogClose}/>}
      </>
    ) : <>
      <DialogContent>
        {/* {formContent === "power" && <ChangePower power_periods={contract.contracted_power_period} onClose={handleDialogClose}/>}
        {formContent === "reclam" && <ReclamATC />} */}
      </DialogContent>
      <DialogActions/>
    </>}
  </Dialog>
}

export default ModificationDialog;